module.exports = __webpack_public_path__ + "img/22.d0394a53.jpg";